import { Component, Input, OnInit, TemplateRef } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-confirm-modal',
  templateUrl: './confirm-modal.component.html',
  styleUrls: ['./confirm-modal.component.scss']
})
export class ConfirmModalComponent {
  @Input() title: string = 'Confirmation'
  @Input() body: string | TemplateRef<any> = '';
  @Input() cancelButton: string = 'Cancel';
  @Input() confirmButton: string = 'Confirm';

  constructor(public modal: NgbActiveModal) { }
}
